import React, { useState, useEffect } from 'react';

export default function Modal({ isOpen, onClose, lockClose, children }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setIsVisible(true), 10);
      document.body.style.overflow = 'hidden';
    } else {
      setIsVisible(false);
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      {/* Backdrop with blur — not clickable when locked */}
      <div
        onClick={lockClose ? undefined : onClose}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(30, 20, 15, 0.88)',
          backdropFilter: isVisible ? 'blur(8px)' : 'blur(0px)',
          WebkitBackdropFilter: isVisible ? 'blur(8px)' : 'blur(0px)',
          opacity: isVisible ? 1 : 0,
          transition: 'all 0.4s ease-out',
          cursor: lockClose ? 'default' : 'pointer'
        }}
      />

      {/* Modal content */}
      <div style={{
        position: 'relative',
        width: '100%',
        maxWidth: '500px',
        maxHeight: '90vh',
        overflowY: 'auto',
        transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(-50px) scale(0.95)',
        opacity: isVisible ? 1 : 0,
        transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)'
      }}>
        {/* Close button — hidden when locked */}
        {!lockClose && (
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              background: 'transparent',
              border: '3px solid #2d2d2d',
              borderRadius: '50%',
              width: '36px',
              height: '36px',
              color: '#2d2d2d',
              fontSize: '18px',
              fontWeight: 'bold',
              cursor: 'pointer',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.15s ease',
              lineHeight: 1
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(0,0,0,0.15)';
              e.currentTarget.style.transform = 'scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            ✕
          </button>
        )}

        {/* Modal inner content - Purple card */}
        <div style={{
          background: '#7B68AE',
          borderRadius: '24px',
          padding: '36px 28px 28px',
          boxShadow: '0 12px 50px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.15)',
          border: '4px solid #2d2d2d',
          position: 'relative',
          overflow: 'hidden',
          fontFamily: "'Patrick Hand', cursive"
        }}>
          {/* Sketchy inner border effect */}
          <div style={{
            position: 'absolute',
            top: '6px',
            left: '6px',
            right: '6px',
            bottom: '6px',
            border: '2px solid rgba(255,255,255,0.12)',
            borderRadius: '18px',
            pointerEvents: 'none'
          }} />

          {children}

          {/* Footer branding */}
          <div style={{
            textAlign: 'center',
            marginTop: '20px',
            paddingTop: '16px',
            borderTop: '2px dashed rgba(255,255,255,0.15)'
          }}>
            <span style={{
              fontFamily: "'Patrick Hand', cursive",
              fontSize: '22px',
              color: '#2d2d2d',
              fontWeight: '700',
              letterSpacing: '0.5px'
            }}>
              Fake Goblynz
            </span>
          </div>
        </div>
      </div>

      {/* Google Font for handwritten feel */}
      <link href="https://fonts.googleapis.com/css2?family=Fredoka+One&family=Patrick+Hand&display=swap" rel="stylesheet" />
    </div>
  );
}
